import { setNestedObjectValues } from 'formik'

function hasFormikValidationErrors(errors) {
  if (errors == null || typeof errors !== 'object') return false
  if (Array.isArray(errors)) {
    return errors.some((item) => {
      if (item == null || item === '') return false
      if (typeof item === 'string') return item.length > 0
      return hasFormikValidationErrors(item)
    })
  }
  return Object.keys(errors).some((key) => {
    const v = errors[key]
    if (v == null || v === '') return false
    if (typeof v === 'string') return v.length > 0
    return hasFormikValidationErrors(v)
  })
}

/**
 * Runs Formik validation; on failure marks fields touched and shows Snackbar via setErrore.
 * On success calls formik.handleSubmit() (same as clicking submit with valid data).
 */
async function submitFormikWithValidationToast(formik, setErrore) {
  const errors = await formik.validateForm(formik.values)
  if (hasFormikValidationErrors(errors)) {
    formik.setTouched(setNestedObjectValues(formik.values, true), false)
    Object.keys(errors).map((key) => setErrore(`Controlla il campo ${key}`))
    console.error('form-errors: ', errors)
    return false
  }
  formik.handleSubmit()
  return true
}

export default submitFormikWithValidationToast
